import axios from 'axios';

/**
 * This function is for triggering build hooks for websites.
 * @param {Object} activeBusiness - The current active business intended to build site
 * @param {string} token - User token (admin, owner, etc.)
 */
export default (id, token) => {
  console.log('inside of build');
  const headers = token ? { headers: { Authorization: `Bearer ${token}` } } : null;
  axios
    .get(`/api/proxy/v2/businesses/${id}/settings`, headers)
    .then(({ data }) => {
      if (data.netlifyId) {
        axios
          .post(`https://api.netlify.com/build_hooks/${data.netlifyId}`)
          .then(response => {
            console.log('response: ', response);
          })
          .catch(err => {
            console.error(err);
            return null;
          });
      }
    })
    .catch(err => {
      console.log(err);
    });
};



// WEBPACK FOOTER //
// ./src/helpers/buildNetlify.js